var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("\n    "+_vm._s(JSON.parse(_vm.element.info).name ?
    JSON.parse(_vm.element.info).name : _vm.val.widget_master.name)+"\n  ")]),_vm._v(" "),_c('iframe',{staticClass:"analytic-box-widget",attrs:{"src":_vm.element.info ? JSON.parse(_vm.element.info).url : ''}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5457aa07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-card/jAnalytic2Widget.vue
// module id = null
// module chunks = 